import React from "react";
import { Link, useLocation } from "react-router-dom";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { connect } from "react-redux";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

const Breadcrumb = (props) => {
  const location = useLocation();

  const { user } = props;

  const { hasPermissions } = useRequiredAuth();

  return (
    <>
      <div className="d-flex bread-crumb align-items-center flex-wrap">
        <HorizontalRuleIcon className="rotated" />

        {hasPermissions([
          "IS_HR",
          "IS_CBM",
          "IS_DAF",
          "IS_TEST_USER",
          "IS_STRUCTURE_OVERSIGHT",
        ]) && (
          <>
            <Link
              style={{ textDecoration: "none", color: "#fff" }}
              to="/structure/units"
              className={` px-1 rounded   ${
                location.pathname.includes("/structure/units")
                  ? " active  "
                  : " "
              }`}
            >
              <span className="text-truncate  menu-item">Units</span>
            </Link>
            <HorizontalRuleIcon className="rotated" />
          </>
        )}

        {hasPermissions([
          "IS_HR",
          "IS_CBM",
          "IS_DAF",
          "IS_TEST_USER",
          "IS_STRUCTURE_OVERSIGHT",
        ]) && (
          <>
            <Link
              style={{ textDecoration: "none", color: "#fff" }}
              to="/structure/positions"
              className={`px-1 rounded ${
                location.pathname.includes("/structure/positions")
                  ? " active  "
                  : " "
              }`}
            >
              <span className="text-truncate menu-item">Positions</span>
            </Link>
            <HorizontalRuleIcon className="rotated" />
          </>
        )}

        {user?.selectedEntitySector?.id ===
          "1203000001-090000000000000001-11" && (
          <>
            <HorizontalRuleIcon className="rotated" />
            <Link
              style={{ textDecoration: "none", color: "#fff" }}
              to="/structure/rra-departments"
              className={`  px-1 rounded  ${
                location.pathname.includes("/structure/rra-departments")
                  ? "active"
                  : " "
              }`}
            >
              <span className="text-truncate  menu-item">RRA Departments</span>
            </Link>
            <HorizontalRuleIcon className="rotated" />
          </>
        )}

        {hasPermissions([
          "IS_HR",
          "IS_CBM",
          "IS_DAF",
          "IS_STRUCTURE_OVERSIGHT",
        ]) && (
          <>
            <Link
              style={{ textDecoration: "none", color: "#fff" }}
              to="/structure/organigram"
              className={`  px-1 rounded  ${
                location.pathname.includes("/structure/organigram")
                  ? "active"
                  : " "
              }`}
            >
              <span className="text-truncate  menu-item">Organigram </span>
            </Link>
            <HorizontalRuleIcon className="rotated" />
          </>
        )}

        {hasPermissions(["IS_STRUCTURE_OVERSIGHT"]) && (
          <>
            <Link
              style={{ textDecoration: "none", color: "#fff" }}
              to="/structure/oversight"
              className={`  px-1 rounded  ${
                location.pathname.includes("/structure/oversight")
                  ? "active"
                  : " "
              }`}
            >
              <span className="text-truncate  menu-item">Oversight</span>
            </Link>
            <HorizontalRuleIcon className="rotated" />
          </>
        )}
        {hasPermissions([
          "IS_HEAD_OF_UNIT",
          "IS_HR",
          "IS_CBM",
          "IS_HEAD_OF_INSTITUTION",
        ]) &&
          [
            "2000000000-010200000000000000",
            "2001000000-090000000000000000",
            "0302000000-060300000000000000",
          ].includes(user?.selectedEntitySector?.entityId) && (
            <>
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to="/structure/job-responsibilities"
                className={`  px-1 rounded  ${
                  location.pathname.includes("/structure/job-responsibilities")
                    ? "active"
                    : " "
                }`}
              >
                <span className="text-truncate  menu-item">
                  Job Responsibilities{" "}
                </span>
              </Link>
              <HorizontalRuleIcon className="rotated" />
            </>
          )}
      </div>
    </>
  );
};

const mapStateToProps = ({ user }) => {
  return { user };
};
export default connect(mapStateToProps)(Breadcrumb);
